import { Heading, HStack, StackProps, VStack } from "@chakra-ui/react"
import React, { PropsWithChildren, useState } from "react"

export type CardProps = {
	title: string
	action?: React.ReactNode
	alwaysShowAction?: boolean
}

export const Card: React.FC<CardProps & PropsWithChildren & StackProps> = ({ title, children, action, alwaysShowAction, ...props }) => {
	const [isHovered, setIsHovered] = useState(false)

	return (
		<VStack w="full" align="stretch" {...props} rounded="xl" bgColor="grayscale.off-white" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
			<HStack w="full" bgColor="grayscale.background" p="4" maxH="12" roundedTop="xl" justify="space-between">
				<Heading fontSize="sm" color="grayscale.title">
					{title}
				</Heading>
				{(isHovered || alwaysShowAction) && action}
			</HStack>
			{children}
		</VStack>
	)
}
